const capitalizeFirstLetter = (word: string) => {
  if (typeof word !== 'string' || !word) return '';
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export default capitalizeFirstLetter;
